// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.MP3 = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MP3 = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var MP3 = _exports.MP3 = function MP3(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 12.0497V15.6861H5.85582V13.44H5.88601L6.75959 15.663H7.30646L8.18004 13.4524H8.21023V15.6861H9.06605V12.0497H7.97763L7.05433 14.3011H7.01172L6.08842 12.0497H5Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.61426 15.6861H10.4932V14.5568H11.0898C11.9225 14.5568 12.4427 14.0632 12.4427 13.3086C12.4427 12.5611 11.9331 12.0497 11.1164 12.0497H9.61426V15.6861ZM10.4932 13.8643V12.7582H10.9264C11.3206 12.7582 11.5319 12.9712 11.5319 13.3086C11.5319 13.6442 11.3206 13.8643 10.9264 13.8643H10.4932Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.252 15.7358C15.1043 15.7358 15.7098 15.2848 15.708 14.6527C15.7098 14.2053 15.4168 13.8857 14.8557 13.82V13.7915C15.2765 13.7312 15.5748 13.4489 15.5731 13.0405C15.5748 12.4474 15.0386 12 14.2591 12C13.4743 12 12.9026 12.4545 12.8955 13.1009H13.7354C13.7425 12.8523 13.9662 12.6854 14.2591 12.6854C14.5379 12.6854 14.7279 12.854 14.7261 13.0973C14.7279 13.3494 14.5042 13.5234 14.181 13.5234H13.8277V14.1484H14.181C14.5486 14.1484 14.7883 14.3295 14.7847 14.5852C14.7883 14.8427 14.5681 15.022 14.2556 15.022C13.9449 15.022 13.7158 14.8569 13.7069 14.6172H12.8227C12.8298 15.2741 13.4211 15.7358 14.252 15.7358Z",
      fill: "currentColor"
    }));
  };
});
